import React from 'react';
import { generatePath, useHistory } from 'react-router';

import { useAppSelector, useTranslation, useAppDispatch } from 'client/hooks';
import { setBannerUnlockLevelState } from 'client/redux/ui';
import { selectUser } from 'client/redux/user/selectors';
import { selectLang } from 'client/redux/settings/selectors';
import { USER_PROFILE_INVESTOR_ROUTE } from 'client/constants/routes';

import BannerLayout from '../BannerLayout';
import { useUnblockLevelBannerVisibility } from './hooks';

import css from './UnlockLevel.module.scss';

const BannerUnlockLevel = () => {
  const { translate } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const user = useAppSelector(selectUser);
  const lang = useAppSelector(selectLang);
  const isBannerVisible = useUnblockLevelBannerVisibility();

  const onUnlockLevelClick = () => {
    history.push(generatePath(USER_PROFILE_INVESTOR_ROUTE, { lang }));
    dispatch(setBannerUnlockLevelState('hidden'));
  };

  const onCloseBtnClick = () => dispatch(setBannerUnlockLevelState('hidden'));

  return (
    <BannerLayout
      className={css.unblockLevel}
      visible={isBannerVisible}
      closeBtnClassName={css.closeBtn}
      size="large"
      onCloseClick={onCloseBtnClick}
    >
      <div className={css.content}>
        <div className={css.text}>{translate(`bannerUnlockLevel.text`, { name: user.name || '' })}</div>
        <button className={css.actionBtn} onClick={onUnlockLevelClick}>
          {translate(`bannerUnlockLevel.buttonLabel`)}
        </button>
      </div>
    </BannerLayout>
  );
};

export default BannerUnlockLevel;
